var React = require('react');

function OnePlusLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M33 2h9v6h6v9h-6v6h-9v-6h-6V8h6V2zm2 2v6h-6v5h6v6h5v-6h6v-5h-6V4h-5zM14.863.93l9.137 4V47H4.605V18.604L0 19.628V5.886L14.863.93zM2 7.328v9.806l4.605-1.024V45h7.209V3.388L2 7.328zm13.814-3.799V45H22V6.237L15.814 3.53z"}));
}

OnePlusLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = OnePlusLight;

OnePlusLight.default = OnePlusLight;
